"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TIMEOUT = exports.PROD_APIKEY = exports.DEV_APIKEY = exports.API_VERSION = exports.API_NAME = void 0;
exports.API_NAME = 'notarius-ex';
exports.API_VERSION = 'v1';
exports.DEV_APIKEY = 'c9aab6a3-8c94-44d6-ba56-6ab5b5ad2471';
exports.PROD_APIKEY = '8cc67322-7dd8-43c9-b820-506b57212d8a';
exports.TIMEOUT = 10000;